
<validation-observer ref="form" @submit.stop.prevent="() => {}" v-slot="{ invalid }">
  <modal-window>
    <h1 class="mb-4">Send as E-Mail</h1>
    <form>
      <div class="label mt-2">To E-Mail</div>
      <multiselect
        v-model="chosenRecipients"
        placeholder="Search for or enter recipient email"
        label="name"
        name="chosenRecipientsSelect"
        track-by="name"
        :options="options"
        :multiple="true"
        open-direction="bottom"
        :taggable="true"
        @tag="(tag) => addRecipient(tag, 'to')"
        :internal-search="false"
        :hide-selected="true"
        :options-limit="100"
        @search-change="searchReceivers"
        tagPlaceholder="Press enter to add the address"
        noOptions="Enter at least one character"
      >
        <template slot="tag" slot-scope="props">
          <div class="multiselect-tag">
            <div :title="props.option.email" v-b-tooltip:hover>
              <span v-if="props.option.name !== props.option.email"><i class="far fa-envelope"></i></span>
              {{ props.option.name }}
            </div>
            <i class="far fa-times cursor-pointer" @click="props.remove(props.option)"></i>
          </div>
        </template>
        <template slot="option" slot-scope="props">
          <span v-if="!props.option.isTag">
            <i class="far fa-envelope"></i>
            {{ props.option.name }}
          </span>
          <span v-else>
            {{ props.option.label }}
          </span>
        </template>
        <template slot="noOptions">
          <i class="far fa-search"></i>
          Enter at least one character
        </template>
      </multiselect>

      <div class="label mt-2">Cc E-Mail</div>
      <multiselect
        v-model="chosenRecipientsCc"
        placeholder="Search for or enter recipient email"
        label="name"
        track-by="name"
        :options="options"
        :multiple="true"
        open-direction="bottom"
        :taggable="true"
        @tag="(tag) => addRecipient(tag, 'cc')"
        :internal-search="false"
        :hide-selected="true"
        :options-limit="100"
        @search-change="searchReceivers"
        tagPlaceholder="Press enter to add the address"
        noOptions="Enter at least one character"
      >
        <template slot="tag" slot-scope="props">
          <div class="multiselect-tag">
            <div :title="props.option.email" v-b-tooltip:hover>
              <span v-if="props.option.name !== props.option.email"><i class="far fa-envelope"></i></span>
              {{ props.option.name }}
            </div>
            <i class="far fa-times cursor-pointer" @click="props.remove(props.option)"></i>
          </div>
        </template>
        <template slot="option" slot-scope="props">
          <span v-if="!props.option.isTag">
            <i class="far fa-envelope"></i>
            {{ props.option.name }}
          </span>
          <span v-else>
            {{ props.option.label }}
          </span>
        </template>
        <template slot="noOptions">
          <i class="far fa-search"></i>
          Enter at least one character
        </template>
      </multiselect>

      <hr />

      <ValidationProvider name="subject" rules="required" v-slot="{ errors }">
        <div class="form-group">
          <input
            type="text"
            id="subject"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': !!errors[0] }"
            v-model="sendAsEmail.subject"
            placeholder="Subject of the E-Mail"
          />

          <div class="invalid-feedback">Subject is required</div>
        </div>
      </ValidationProvider>

      <div class="form-group">
        <wysiwig-editor v-model="sendAsEmail.body" placeholder="Text content of the email"></wysiwig-editor>
      </div>
      <hr />
      <div class="input-group input-group-sm mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text">Reply To</div>
        </div>
        <select class="form-control" v-model="sendAsEmail.replyTo">
          <option v-for="replyTo in sendAsEmailOptions.replyToAddresses" :value="replyTo.emailAddress" :key="replyTo.emailAddress">
            {{ replyTo.description }}
          </option>
        </select>

        <div class="invalid-feedback">E-Mail "CC" must be one or multiple e-mail addresses (separated with ,)</div>
      </div>
    </form>

    <template v-slot:sidebar>
      <div class="label mt-4">Generate E-Mail</div>

      <b-form-checkbox
        class="mb-1"
        v-model="sendAsEmail.includeChecklists"
        :value="true"
        :unchecked-value="false"
        @input="optionsChanged = true"
      >
        Include checklists
      </b-form-checkbox>

      <b-form-checkbox
        class="mb-1"
        v-model="sendAsEmail.includeComments"
        :value="true"
        :unchecked-value="false"
        @input="optionsChanged = true"
      >
        Include comments
      </b-form-checkbox>

      <b-form-checkbox
        class="mb-1"
        v-model="sendAsEmail.includeLabels"
        :value="true"
        :unchecked-value="false"
        @input="optionsChanged = true"
      >
        Include labels
      </b-form-checkbox>

      <b-form-checkbox
        class="mb-1"
        v-model="includeAttachments"
        :value="true"
        :unchecked-value="false"
        @input="
          includeAttachmentsClicked();
          optionsChanged = true;
          selectedAttachments = [];
        "
      >
        Include attachments
      </b-form-checkbox>

      <small class="mt-2 d-block text-center" v-if="includeAttachments">
        <i class="far fa-exclamation-triangle"></i>
        <br />
        Specify the files, that will be attached to the email:

        <div class="text-left">
          <div v-for="(t, index) in sendableAttachments" :key="index">
            <checkbox-with-label
              :value="attachmentIsSelected(t)"
              :labelStyle="'regular'"
              :label="t.fileName"
              @input="processEmailAttachmentSelection(t)"
            />
          </div>
        </div>
      </small>

      <button
        class="btn btn-block mt-4"
        :class="{ 'btn-success': optionsChanged, 'btn-info': !optionsChanged }"
        id="createChecklist"
        @click="generateText"
      >
        <i class="far fa-cogs icon-left"></i>
        Update text
      </button>

      <div class="label mt-4">Send E-Mail</div>

      <div class="label mb-2" v-b-tooltip.hover.top :title="invalid || !recipientAddresses ? 'Disabled: Please check your input' : ''">
        <button class="btn btn-block btn-sm btn-success" @click="sendEmail()" :disabled="invalid || loading || !recipientAddresses">
          <i class="far fa-paper-plane" v-if="!loading"></i>
          <i class="far fa-spin fa-sync" v-if="loading"></i>
          Send E-Mail
        </button>
      </div>

      <div class="label mb-2">
        <button class="btn btn-block btn-sm btn-secondary" @click="close()">
          <i class="far fa-times"></i>
          Close window
        </button>
      </div>
    </template>
  </modal-window>
</validation-observer>
